import React, { useEffect, useState } from "react";
import "../styles/AuthViewModal.css";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

const AuthViewModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const navigate = useNavigate();
  const [exitAnim, setExitAnim] = useState(false);

  useEffect(() => {
    const { data: listener } = supabase.auth.onAuthStateChange(
      async (_event, session) => {
        if (!session) return;

        const user = session.user;

        const { data, error } = await supabase
          .from("users")
          .select("display_name")
          .eq("id", user.id)
          .maybeSingle();

        if (!error && data?.display_name) {
          navigate("/fiksukaappi");
        } else {
          navigate("/create-profile");
        }

        setExitAnim(true);
        setTimeout(() => {
          onClose();
        }, 300);
      }
    );

    return () => {
      listener?.subscription?.unsubscribe();
    };
  }, [navigate, onClose]);

  const handleClose = () => {
    setExitAnim(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const redirectUrl =
    process.env.REACT_APP_REDIRECT_URL || `${window.location.origin}/auth`;

  return (
    <div className="auth-modal-backdrop">
      <div
        className={`auth-modal-content ${exitAnim ? "auth-modal-exit" : ""}`}
      >
        <button className="close-button" onClick={handleClose}>
          ×
        </button>
        <Auth
          supabaseClient={supabase}
          view="magic_link"
          redirectTo={redirectUrl}
          appearance={{ theme: ThemeSupa }}
          theme="default"
          providers={["google"]}
        />
      </div>
    </div>
  );
};

export default AuthViewModal;
